import React from 'react'
import { Button, Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { useWindowSize } from 'src/app/hooks'
import { PlusOutlined } from '@ant-design/icons'
import { CustomCol, PageTitle } from 'src/components'

interface OffersPageHeaderProps { handleButtonClick: () => void }

const OffersPageHeader: React.FC<OffersPageHeaderProps> = ({ handleButtonClick }) => {
  const { t } = useTranslation()
  const { isMobile } = useWindowSize()

  return <Row className={isMobile && 'pl-3 pr-3'}>
    <CustomCol xs={10}>
      <PageTitle>{t('Offers.Title')}</PageTitle>
    </CustomCol>
    <CustomCol xs={14}>
      <Button
        type='primary'
        className={isMobile ? 'radius-100 mb-5' : 'radius-100 float-right'}
        block={isMobile}
        icon={<PlusOutlined />}
        onClick={handleButtonClick}
      >{t('RequestProposal.Button')}
      </Button>
    </CustomCol>
  </Row>
}

export default OffersPageHeader
